import { Component, OnInit } from '@angular/core';
import { TableMode } from 'src/app/components/grid/grid.component';
import { FieldDataType } from 'src/app/components/grid/FieldDataType';
import { QueryOperand } from 'src/app/components/grid/QueryOperand';
import { ITableData } from 'src/app/components/grid/ITableData';
import { IColumn } from 'src/app/components/grid/IColumn';
import { GridUtil } from 'src/app/components/grid/GridUtil';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { ExamService } from 'src/app/services/exam-service.service';

@Component({
  selector: 'app-extra-fields-label',
  templateUrl: './extra-fields-label.component.html',
  styleUrls: ['./extra-fields-label.component.scss']
})
export class ExtraFieldsLabelComponent implements OnInit {

  gridName = 'extraFieldsLabelGrid';
  constructor(private examService: ExamService, private eventService: EventService) { }

  async ngOnInit() {
    GridUtil.setClearGridSelection();
    this.refreshData();
  }
  data: ITableData = {
    tableRows: [],
    tableParams: {
      filterParams: [
        {
          fieldName: 'examinationID',
          fieldValue: `${this.examService.selectedExamIds}`,
          queryOperand: QueryOperand['=='],
          static: true
        }
      ],
      sortParam: {
        fieldName: "",
        orderDirection: 0,
      },
      pageInfo: {
        previousPageSize: 50,
        page: 1,
        pageSize: 50,
        recordCount: 0,
        pageCount: 0
      },
      tableMode: TableMode.serverProcessing,
      selectAll: false
    }
  };

  columns: IColumn[] = [
    {
      displayName: 'Examination ID',
      fieldName: 'examinationID',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Label Field1',
      fieldName: 'labelField1',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Label Field2',
      fieldName: 'labelField2',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Label Field3',
      fieldName: 'labelField3',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Allow Gender',
      fieldName: 'allowGender',
      fieldDataType: FieldDataType.boolean,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Allow Passport',
      fieldName: 'allowPassport',
      fieldDataType: FieldDataType.boolean,
      searchable: true,
      orderable: true,

    }
  ];

  onRowClick(idx: any) {
    if (!this.data?.tableRows) { //Just in case tableRows might still not be ready
      setTimeout(() => this.onRowClick(idx), 50);
      return;
    }
    let storedIds = GridUtil.getSelectedDataID(this.gridName) ?? [];
    const selectedXtra: any[] = idx.map(x => this.data.tableRows[x]).filter(Boolean);
    let selectedDataRowsId = storedIds.length > 0 ? storedIds : selectedXtra.map(x => x.id);
    GridUtil.setRowCliclk(this.gridName, idx, selectedDataRowsId);
    // this.candidateService.setSelectedXtraField(selectedXtra);
  }

  async refreshData() {
    const res = await this.examService.getExtraFieldsLabel(this.data.tableParams) as [];
    if (!res || res.length === 0) {
      return;
    }
    this.data.tableRows = res.slice(1, res.length);
    setTimeout(() => {
      this.eventService.gridDataLoadedEvent.next(true);
    });
  }

}
